import ActionResultContent from './component';

export default ActionResultContent;
